import React from "react";
import { getDispositionColor } from "../utils/dispositionColors";

const HouseholdQuickActions = ({
  disposition,
  options,
  dispositionColors,
  showDisposition = true,
  showAttempt = true,
  busy = false,
  onDispositionChange,
  onAttempt,
}) => (
  <div className="flex items-center justify-center gap-2">
    {showDisposition && (
      <select
        aria-label="Household disposition"
        value={disposition || ""}
        disabled={busy}
        onChange={(e) => onDispositionChange(e.target.value)}
        className="min-w-[200px] text-sm font-outfit font-medium rounded-lg border border-gray-300 md:py-3 py-2 pl-3 pr-8 disabled:opacity-50"
        style={{
          color: disposition ? getDispositionColor(disposition, dispositionColors) : undefined,
        }}
      >
        <option value="">--</option>
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
            style={{ color: getDispositionColor(option.value, dispositionColors) }}
          >
            {option.label}
          </option>
        ))}
      </select>
    )}
    {showAttempt && (
      <button
        type="button"
        disabled={busy}
        onClick={onAttempt}
        className="md:py-3 py-1 md:px-4 px-2 inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent bg-canvas-primary text-white hover:scale-95 disabled:opacity-50 disabled:pointer-events-none"
      >
        Attempted
      </button>
    )}
  </div>
);

export default HouseholdQuickActions;
